<template>
  <div class="table_card">
    <div class="table_card__head" style="padding: 35px 25px; position: relative;">
      <v-layout row wrap fill-height>
        <v-flex xs12 lg6 class="head_contain">
          <p class="table_card__head--title">
            Calendario de tareas
          </p>
          <div class="work_calendar__header_buttons">
            <button
              style="padding-left: 20px;"
              class="faccess_button my-3"
              @click="creating_task = true">
              <span class="material-icons">add</span>
              Crear evento
            </button>
            <!-- <button
              class="faccess_button my-3"
              style="margin-left: 20px;"
              @click="$router.push({name: 'provider_tasks'})">
              Eventos
            </button> -->
          </div>
        </v-flex>
      </v-layout>
    </div>

    <div class="work_calendar">

      <div class="work_calendar__date_picker">
        <v-menu
          transition="scale-transition"
          offset-y
          max-width="290px">

          <template v-slot:activator="{ on, attrs }">
            <input
              class="work_calendar__date_picker--month_picker work_calendar__input"
              type="text"
              :value="formatted_date"
              v-bind="attrs"
              v-on="on">
          </template>

          <v-date-picker
            v-model="selected_date"
            type="month"
            no-title
            @change="getTasks()">
          </v-date-picker>
        </v-menu>

        <div
          class="buttom_reload">
          <img src="@/assets/img/icons/refresh-icon.svg"
          @click="getTasks()">
        </div>
      </div>

      <div style="display: flex; justify-content: space-between;">
        <work-calendar
          :currentMonth="selected_date"
          :tasks="tasks"
          @find-task-info="getTaskInfo($event)">
        </work-calendar>

        <task-info-card
          :colors="task_colors"
          @open-modal="editing_task = true"
          @check-task="checkTask()">
        </task-info-card>
      </div>
    </div>

    <modal-task-creation
      v-if="creating_task"
      :providers="providers"
      @create-task="createTask($event)"
      @close-modal="creating_task = false">
    </modal-task-creation>

    <modal-task-edition
      v-if="editing_task"
      :providers="providers"
      :taskTypes="task_types"
      :taskColors="task_colors"
      @edit-task="editTask($event)"
      @close-modal="editing_task = false">
    </modal-task-edition>

  </div>
</template>

<script>
import moment from 'moment'
import WorkCalendar from './WorkCalendar.vue'
import TaskInfoCard from './TaskInfoCard.vue'
import ModalTaskCreation from './ModalTaskCreation.vue'
import ModalTaskEdition from './ModalTaskEdition.vue'

export default {
  components: {
    WorkCalendar,
    TaskInfoCard,
    ModalTaskCreation,
    ModalTaskEdition
  },
  data(){
    return {
      creating_task: false,
      editing_task: false,
      selected_date: moment().format('YYYY-MM'),
      tasks: [],
      providers: [],
      task_types: [
        { type: 'Mantenimiento', color: '#D50B00' },
        { type: 'Inspecciones', color: '#2C9BE5' },
        { type: 'Simulacro', color: '#3CB679' },
        { type: 'Otro', color: '#F6BF26' }
      ],
      task_colors: {
        'Mantenimiento': '#D50B00',
        'Inspecciones': '#2C9BE5',
        'Simulacro': '#3CB679',
        'Otro': '#F6BF26'
      }
    }
  },
  computed: {
    formatted_date(){
      return this.selected_date ? moment(this.selected_date).format('MMMM YYYY').toUpperCase() : ''
    },
    formatted_month(){
      return this.selected_date+'-01'
    }
  },
  methods: {
    getTasks(){
      this.updateSelectedTask('')

      try {
        this.$http.get('provider_tasks', {
          params: {
            company_id: this.getCompany().id,
            date: this.selected_date
          },
          headers: {
            "X-Device-ID": this.getDeviceId(),
            "Authorization": 'Bearer '+this.getUserToken()
          }

        }).then(response => {
          this.tasks = response.body.data

          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }), function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }

      } catch(e){
        this.updateAlertMessage(e.message)
        this.updateIsInAlert(true)
      }
    },

    getProviders(){
      try{
        this.$http.get('providers', {
          params: {
            company_id: this.getCompany().id
          },
          headers: {
            "Authorization": 'Bearer '+this.getUserToken(),
            "X-Device-ID": this.getDeviceId()
          }

        }).then(response => {
          this.providers = response.body.data

          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }), function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }

      } catch(e){
        this.updateAlertMessage(e.message)
        this.updateIsInAlert(true)
      }
    },

    getTaskInfo(task_id){
      try {
        this.$http.get('provider_tasks/find_task_info', {
          params: {
            provider_task: task_id
          },
          headers: {
            "Authorization": 'Bearer ' + this.getUserToken(),
            "X-Device-ID": this.getDeviceId()
          }

        }).then(response => {
          this.updateSelectedTask(response.body.data)

          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }), function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }

      } catch(e){
        this.updateAlertMessage(e.message)
        this.updateIsInAlert(true)
      }
    },

    createTask(task){
      try {
        this.$http.post('provider_tasks/create_task', {
          data: this.encrypt(task).toString()
        },
        {
          headers: {
            "Authorization": 'Bearer '+this.getUserToken(),
            "X-Device-ID": this.getDeviceId()
          }

        }).then(response => {
          this.updateAlertMessage(response.body.ans)
          this.updateIsInAlert(true)
          this.getTasks()

          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }), function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }
      } catch(e){
        this.updateAlertMessage(e.message)
        this.updateIsInAlert(true)
      }
    },

    editTask(task){
      console.log("TASK", task)
      try {
        this.$http.put('provider_tasks/edit_task', {
          data: this.encrypt(task).toString()
        },
        {
          params: {
            provider_task: this.getSelectedTask().id
          },
          headers: {
            "Authorization": 'Bearer '+this.getUserToken(),
            "X-Device-ID": this.getDeviceId()
          }

        }).then(response => {
          if(response.status == 200){
            this.updateAlertMessage("Evento editado correctamente")
            this.updateIsInAlert(true)
            this.getTasks()
            this.updateSelectedTask(response.body.data)
          }

          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }), function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }

      } catch(e){
        this.updateAlertMessage(e.message)
        this.updateIsInAlert(true)
      }
    },

    checkTask(){
      try {
        this.$http.put('provider_tasks/check_event', {},
        {
          params: {
            provider_task: this.getSelectedTask().id
          },
          headers: {
            "Authorization": 'Bearer ' + this.getUserToken(),
            "X-Device-ID": this.getDeviceId()
          }

        }).then(response => {
          this.updateSelectedTask(response.body.data)

          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }), function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }

      } catch(e){
        this.updateAlertMessage(e.message)
        this.updateIsInAlert(true)
      }
    }
  },
  mounted(){
    this.getTasks()
    this.getProviders()
    scrollTo(0,0)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/SGSST/work_calendar/Index.vue